<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "App",
});
</script>

<style>
:root {
  --color-primary: #4a7eb8;
  --color-secondary: #6b8caa;
  --color-accent: #c9a962;
  --color-bg: #e8f4fc;
  --color-text: #2c4a6e;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: var(--color-bg);
  color: var(--color-text);
  overflow-x: hidden;
}

#app {
  min-height: 100vh;
}

::selection {
  background: rgba(201, 169, 98, 0.3);
  color: #2c4a6e;
}

::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: rgba(74, 126, 184, 0.05);
}

::-webkit-scrollbar-thumb {
  background: rgba(201, 169, 98, 0.3);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(201, 169, 98, 0.5);
}
</style>
